<template>
    <div>
        <headerNotice routerName="商品品牌"></headerNotice>
        <!-- 头部操作栏 -->
        <div class="handleBar">
            <el-button type="primary" @click="addDialog">
                <i class="el-icon-plus"></i> 新增
            </el-button>
        </div>
        <!-- 单位列表 -->
        <div class="unitBox">
            <el-table class="tableBox" :data="items" style="width:100%" fit v-loading="loading">
                <el-table-column align="center" prop="brandName" label="品牌名称"></el-table-column>
                <el-table-column align="center" prop="sort" label="排序"></el-table-column>
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button size="small" type="warning" @click="editBtn(scope.row)">修改</el-button>
                        <el-button size="small" type="danger" @click="deleteBtn(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页-->
            <el-pagination
                class="pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync='currentPage'
                :page-sizes="[10, 20, 30, 40]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
            ></el-pagination>
        </div>

        <!-- 新增框 -->
        <el-dialog title="新增品牌" :visible.sync="showDialog" width="30%">
            <el-form class="signUp_Form" label-width="125px">
                <el-row>
                    <el-col :span="20">
                        <el-form-item label="品牌名称" :rules="[{'required':true}]">
                            <el-input v-model="brandName" placeholder="请输入单位名称" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="saveBox">
                    <el-button type="primary" class="saveUnitBtn" @click="saveUnit">保存</el-button>
                </div>
            </el-form>
        </el-dialog>
        <!--修改dialog-->
        <el-dialog title="品牌修改" :visible.sync="editDialog">
            <el-form
                :model="editForm"
                class="signUp_Form"
                label-position="right"
                label-width="125px"
            >
                <div>
                    <el-row>
                        <el-col :sm="12">
                            <el-form-item label="品牌名称：">
                                <el-input
                                    class="inputStyle"
                                    v-model="editForm.brandName"
                                    size="small"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :sm="12">
                            <el-form-item label="排序：">
                                <el-input
                                    class="inputStyle"
                                    type="number"
                                    v-model="editForm.sort"
                                    size="small"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <div style="text-align:center;">
                    <el-button type="primary" @click="editSaveData">保存</el-button>
                </div>
            </el-form>
        </el-dialog>
        <!--dialog end-->
    </div>
</template>

<script>
import headerNotice from './../../components/common/headerNotice.vue'
export default {
    data() {
        return {
            loading: true,
            totalCount: 0,//总数据条数
            currentPage: 1,
            maxResultCount: 10, //默认一页显示的个数,
            items: [],
            showDialog: false,//增加分类弹框
            brandName: '',
            editDialog: false,//关闭分类弹框
            editForm: {

            },
        }
    },
    components: {
        headerNotice
    },
    mounted() {
        let self = this;
        this.getDatas({
            MaxResultCount: this.maxResultCount,
        })
    },
    methods: {
        //获取列表数据
        getDatas(params) {
            let self = this;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/IAdmintemBrand/GetBrand",
                params: params,
                success(res) {
                    self.items = res.items;
                    self.totalCount = res.totalCount;
                    self.loading = false;
                },
                fail(res) {
                    self.loading = false;
                }
            })
        },
        //添加商品单位
        addDialog() {
            this.showDialog = true;
        },
        //保存添加品牌
        saveUnit() {
            let self = this;
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/IAdmintemBrand/CreateBrand",
                data: {
                    brandID: 0,
                    brandName: this.brandName,
                    status: 0
                },
                success(res) {
                    self.$message({
                        message: '添加成功',
                        type: 'success'
                    });
                    self.getDatas();
                    self.currentPage = 1
                    self.showDialog = false;
                },
                fail(res) {

                }
            })
        },
        //修改单位
        editBtn(row) {
            this.editDialog = true;
            this.editForm = row;
        },
        //修改品牌 保存按钮
        editSaveData() {
            this.editDialog = false;
            let self = this;
            $http.PUT({
                url: this.$store.state.apiUrl + "/api/services/app/IAdmintemBrand/UpdateBrand",
                data: this.editForm,
                success(res) {
                    self.$message({
                        message: '修改成功',
                        type: 'success',
                    });
                    self.getDatas();
                    self.currentPage = 1
                },
                fail(res) {

                }
            })
        },
        //删除单位
        deleteBtn(row) {
            let self = this;
            this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                $http.DELETE({
                    url: this.$store.state.apiUrl + "/api/services/app/IAdmintemBrand/DeleteBrand",
                    params: {
                        Id: row.brandID,
                    },
                    success(res) {
                        self.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        self.getDatas();
                        self.currentPage = 1
                    },
                    fail(res) {

                    }
                })
            }).catch(() => {

            });
        },
        //一页显示多少个
        handleSizeChange(val) {
            this.maxResultCount = val;
            let params = {
                MaxResultCount: val,
            };
            this.getDatas(params);
        },
        //跳转到指定页
        handleCurrentChange(val) {
            this.loading = true;
            let skipCount = (val - 1) * this.maxResultCount;
            let params = {
                SkipCount: skipCount,
                MaxResultCount: this.maxResultCount,
            };
            this.getDatas(params);
        },
    }
}
</script>

<style lang='scss' scoped>
// 头部操作栏
.handleBar {
    margin: 0px 120px;
    margin-top: 20px;
    padding: 20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
// 单位列表
.unitBox {
    padding: 20px 130px;
    .tableBox {
        border: 1px solid #c5c5c5;
    }
    ul {
        li {
            height: 80px;
            border-bottom: 1px solid #c5c5c5;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-left: 20px;
            &:nth-last-child(1){
                border: none;
            }
        }
    }
}
.saveBox {
    width: 100%;
    display: flex;
    justify-content: center;
}
</style>